import {getApiUrl} from '@/api/utils/api-url'

export const getUsnoImage = (imageKey, band) =>
  // `${getApiUrl()}/static/beta_images/USNO1001/USNO${imageKey}${band}.gif`
	//`${getApiUrl()}${imageKey}&cat=VISTA`
	//require("@/assets/crosshair.png")
  // 'http://r01.ds.cs.umu.se/getimage_mongo.php?image=113&filter=1&cat=USNO'
  getApiUrl() + + (imageKey+1) +'&filter=' + band + '&cat=USNO'
